import axios from 'axios'
import * as types from '../mutation-types'

const doToArrayObject = (data) => {
  const arr = []
  let i = 0
  for (i in data) {
    if (data.hasOwnProperty(i)) {
      const inspector = data[i]
      arr.push({ value: inspector.id, text: inspector.name })
    }
  }

  return arr
}

// state
export const state = {
  loading: true,
  inspectors: [],
  error: null,
}

// mutations
export const mutations = {
  [types.GET_INSPECTORS_START] (state) {
    state.loading = true
    state.inspectors = []
    state.error = null
  },

  [types.GET_INSPECTORS_SUCCESS] (state, { data }) {
    state.loading = false
    state.inspectors = doToArrayObject(data)
    state.error = null
  },

  [types.GET_INSPECTORS_ERROR] (state, { error }) {
    state.loading = false
    state.inspectors = []
    state.error = error
  },
}

export const actions = {
  async getInspectors ({ commit }) {
    try {
      commit(types.GET_INSPECTORS_START)

      const { data } = await axios.get('/api/administrations/users/list_agents')

      commit(types.GET_INSPECTORS_SUCCESS, { data: data })
    } catch (e) {
      commit(types.GET_INSPECTORS_ERROR, { error: null })
    }
  },
}

// getters
export const getters = {
  loadingInspector: state => state.loading,
  inspectors: state => state.inspectors,
  errorInspector: state => state.error,
}
